import React from 'react';
import { FaHardHat } from 'react-icons/fa';
import { BRAND } from '../utils/sst';

/**
 * Marca Previx: ícono de casco de seguridad + wordmark.
 */
const BrandLogo: React.FC<{ size?: number; light?: boolean; iconOnly?: boolean }> = ({ size = 40, light = false, iconOnly = false }) => (
  <div style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.28 }}>
    <span
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.28,
        background: `linear-gradient(135deg, ${BRAND.primaryLight}, ${BRAND.primary})`,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: size * 0.56,
        flexShrink: 0,
        boxShadow: '0 4px 12px rgba(15,76,129,0.28)',
      }}
    >
      <FaHardHat />
    </span>
    {!iconOnly && (
      <span style={{ fontSize: size * 0.6, fontWeight: 800, letterSpacing: '-0.02em', color: light ? '#fff' : BRAND.ink, lineHeight: 1 }}>
        Pre<span style={{ color: light ? '#bfe0f2' : BRAND.primaryLight }}>vix</span>
      </span>
    )}
  </div>
);

export default BrandLogo;
